<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Notification Configuration"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card>
        <b-row>
          <template
            v-if="
              configuredList.length ||
              firstRow.length ||
              secondRow.length ||
              thirdRow.length
            "
          >
            <b-col
              md="4"
              v-for="(notification, index) in configuredList"
              :key="index"
              ><div>
                <b-card
                  style="
                    border-radius: 10px;
                    box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
                    min-height: 10rem;
                  "
                >
                  <div class="center">
                    <b-card-img
                      class="card-img-top"
                      :src="getNotificationLogo(notification)"
                      :alt="`${notification.name} notification`"
                    />
                    <div></div>
                  </div>
                  <a href="#"
                    ><span style="right: 15px; top: 10px; position: absolute"
                      ><i class="fa fa-gear fa-lg"></i
                    ></span>
                  </a>
                  <h4 class="text-capitalize">{{ notification.name }}</h4>
                  <p class="description">
                    {{ notification.description }}
                  </p>

                  <b-card-footer class="pt-3 notification-footer">
                    <b-row class="align-items-center justify-content-center">
                      <b-col cols="8" class="text-center">
                        <button
                          type="button"
                          id="gateway-configure"
                          style="border-radius: 7px"
                          class="btn btn-outline-primary"
                          disabled
                        >
                          Configured
                        </button>
                      </b-col>
                      <b-col cols="4" class="text-center d-flex justify-content-center align-items-center">
                        <div class="notification-switch">
                          <c-switch
                            color="primary"
                            v-model="configuredData[index].isActive"
                            variant="pill"
                            @change="inputCheck(notification, index)"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-footer>
                </b-card>
                <b-modal
                  header-class="header-nipige-class"
                  id="payment-notification"
                  size="sm"
                  ref="payment-notification-config"
                  centered
                  hide-footer
                >
                  <h3>Modal</h3>
                </b-modal>
              </div>
            </b-col>

            <b-col
              md="4"
              v-for="notification in firstRow"
              :key="notification.key + notification.serviceProvider"
              ><div>
                <b-card
                  style="
                    border-radius: 10px;
                    box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
                    min-height: 10rem;
                  "
                >
                  <div class="center">
                    <b-card-img
                      class="card-img-top"
                      :src="getNotificationLogo(notification)"
                      :alt="`${notification.name} notification`"
                    />
                    <div></div>
                  </div>
                  <h4 class="text-capitalize">{{ notification.name }}</h4>
                  <p class="description">
                    {{ notification.description }}
                  </p>

                  <b-card-footer class="pt-3" style="text-align: center">
                    <button
                      type="button"
                      style="border-radius: 7px"
                      class="btn btn-primary"
                      @click="onClickConfig(notification.key)"
                    >
                      Configure
                    </button>
                  </b-card-footer>
                </b-card>
                <b-modal
                  header-class="header-nipige-class"
                  id="payment-notification"
                  size="sm"
                  ref="payment-notification-config"
                  centered
                  hide-footer
                >
                  <h3>Modal</h3>
                </b-modal>
              </div>
            </b-col>
          </template>
          <template v-else>
            <b-col cols="12" class="notification-empty-state">
              <div class="notification-empty-title">
                No notification providers found
              </div>
              <p class="notification-empty-text mb-0">
                Notification provider data is not available right now.
              </p>
            </b-col>
          </template>
        </b-row>
        <div class="horizontal-line pb-2" v-if="secondRow.length">
          <h4>SMS Notification</h4>
        </div>
        <b-row>
          <template>
            <b-col
              md="4"
              v-for="notification in secondRow"
              :key="notification.name"
              ><div>
                <b-card
                  style="
                    border-radius: 10px;
                    box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
                  "
                >
                  <div class="center">
                    <b-card-img
                      class="card-img-top"
                      :src="getNotificationLogo(notification)"
                      :alt="`${notification.name} notification`"
                    />
                    <div></div>
                  </div>
                  <h4 class="text-capitalize">{{ notification.name }}</h4>
                  <p class="description">
                    {{ notification.description }}
                  </p>

                  <b-card-footer class="pt-3" style="text-align: center">
                    <button
                      type="button"
                      style="border-radius: 7px"
                      class="btn btn-primary"
                      @click="onClickConfig(notification.key)"
                    >
                      Configure
                    </button>
                  </b-card-footer>
                </b-card>
                <b-modal
                  header-class="header-nipige-class"
                  id="payment-notification"
                  size="sm"
                  ref="payment-notification-config"
                  centered
                  hide-footer
                >
                  <h3>Modal</h3>
                </b-modal>
              </div>
            </b-col>
          </template>
        </b-row>
        <div class="horizontal-line pb-2" v-if="thirdRow.length">
          <h4>Email Notification</h4>
        </div>
        <b-row>
          <template>
            <b-col md="4" v-for="(notification, index) in thirdRow" :key="index"
              ><div>
                <b-card
                  style="
                    border-radius: 10px;
                    box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
                  "
                >
                  <div class="center">
                    <b-card-img
                      class="card-img-top"
                      :src="notification.logo"
                      :alt="`${notification.name} notification`"
                    />
                    <div></div>
                  </div>
                  <h4 class="text-capitalize">{{ notification.name }}</h4>
                  <p class="description">
                    {{ notification.description }}
                  </p>

                  <b-card-footer class="pt-3" style="text-align: center">
                    <button
                      type="button"
                      style="border-radius: 7px"
                      class="btn btn-primary"
                      @click="onClickConfig(notification.key)"
                    >
                      Configure
                    </button>
                  </b-card-footer>
                </b-card>
              </div>
            </b-col>
          </template>
        </b-row>
      </b-card>
    </b-col>
    <b-modal
      id="modalWhatsapp"
      v-model="whatsappModal"
      centered
      title="WhatsApp Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter From Name"
            v-model="whatsConfig.fromName"
          ></b-form-input>
        </b-col>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter From Email"
            v-model="whatsConfig.from "
          ></b-form-input>
        </b-col>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Api Key"
            v-model="whatsConfig.apiKey"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button
            variant="danger"
            block
            @click="whatsappModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveWhatsappConfig"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>

    <!--SMS-->
    <b-modal
      id="modalSMS"
      v-model="smsModal"
      centered
      title="SMS Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-2">
          <b-form-select
            :options="smsProviders"
            placeholder="Service Provider"
            v-model="smsConfig.serviceProvider"
            value-field="name"
            text-field="name"
          ></b-form-select>
        </b-col>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter User Name"
            v-model="smConfig.username"
          ></b-form-input>
        </b-col>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Token"
            v-model="smConfig.token"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button variant="danger" block @click="smsModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveSmsConfig"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>

    <!--Email-->
    <b-modal
      id="modalEmail"
      v-model="emailModal"
      centered
      title="Email Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-2"
          ><b-form-input
            placeholder="Enter Api Key"
            v-model="whatsConfig.apiKey"
          ></b-form-input
        ></b-col>
        <b-col md="6" class="pb-2">
          <b-form-select
            :options="emailProviders"
            placeholder="Service Provider"
            v-model="emailConfig.serviceProvider"
            value-field="name"
            text-field="name"
          ></b-form-select>
        </b-col>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter From Name"
            v-model="whatsConfig.fromName"
          ></b-form-input>
        </b-col>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter From Email"
            v-model="whatsConfig.from "
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button variant="danger" block @click="emailModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="emailSaveConfig"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import { Switch as cSwitch } from "@coreui/vue";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { BUCKET_BASEURL } from "@/services/index";
export default {
  components: {
    profile,
    cSwitch,
    ComponentHeader,
  },
  mixins: [currentUserData],
  data() {
    return {
      currentUserData: "",
      cashOnDelivery: false,
      onlinePayment: false,
      maxAllowedDevices: "",
      firstRow: [],
      secondRow: [],
      thirdRow: [],
      smsProviders: [],
      emailProviders: [],
      whatsConfig: { fromName: "", from: "", apiKey: "" },
      whatsappConfig: {
        tenant: "",
        service: "WHATSAPP",
        serviceProvider: "WHATSAPP",
        enable: false,
        isActive: true,
        config: {},
      },
      emailConfig: {
        tenant: "",
        service: "EMAIL",
        serviceProvider: "SENDGRID",
        isActive: true,
        enable: false,
        config: {},
      },
      smConfig: { username: "", token: "" },
      smsConfig: {
        tenant: "",
        service: "SMS",
        serviceProvider: "",
        isActive: true,
        enable: false,
        config: {},
      },
      whatsappModal: false,
      smsModal: false,
      emailModal: false,
      configuredList: [],
      whatsappConfigured: false,
      inappConfigured: false,
    };
  },
  computed: {
    ...mapState({
      notificationList: (state) => state.tenant.notificationData,
      configuredData: (state) => state.tenant.notificationConfigured,
      serviceProviders: (state) => state.tenant.serviceProviders,
    }),
  },
  methods: {
    getNotificationLogo(notification) {
      const rawKey = (notification && notification.key
        ? notification.key
        : notification && notification.name
        ? notification.name
        : ""
      )
        .toString()
        .toLowerCase();

      // normalise: remove " notification" suffix, spaces and non-letters
      const key = rawKey
        .replace(/notification/g, "")
        .replace(/\s+/g, "")
        .replace(/[^a-z]/g, "");

      // Prefer local, known icons for better reliability
      if (key === "email") {
        return require("@/assets/images/email-notification.svg");
      }
      if (key === "sms") {
        return require("@/assets/images/sms-notification.svg");
      }
      if (key === "whatsapp") {
        return require("@/assets/images/whatsapp-notification.svg");
      }
      if (key === "inapp") {
        return require("@/assets/images/inapp-notification.svg");
      }

      // final fallback to a generic placeholder
      return require("@/assets/images/mob-default-img.svg");
    },
    inputCheck(obj, i) {
      let objB = this.configuredData[i];
      this.smsConfig.isActive = objB.isActive;
      this.smConfig = objB.config;
      this.smsConfig.enable = true;
      this.smsConfig.serviceProvider = objB.serviceProvider;
      this.smsConfig.tenant = objB.tenant;
      this.smsConfig.config = objB.config;
      let payload = this.smsConfig;
      payload.service = objB.service;
      this.$store
        .dispatch("tenant/configureNotificationAction", payload)
        .then(() => {
          this.smConfig = { username: "", token: "" };
          this.getNotificationList();
        });
    },
    async onClickConfig(key) {
      const normalizedKey = (key || "").toString().toLowerCase();
      if (normalizedKey === "whatsapp") {
        this.whatsappModal = true;
      }
      if (normalizedKey === "sms") {
        this.smsModal = true;
      }
      if (normalizedKey === "email") {
        this.emailModal = true;
      }
    },
    getNotificationList() {
      this.$store.dispatch("tenant/setNotificationListData").then(() => {
        this.checkRow();
        this.getConfiguredList();
      });
    },
    getConfiguredList() {
      this.$store
        .dispatch("tenant/setNotificationConfigured", this.$currentUserData._id)
        .then(() => {
          this.configuredList = [];
          for (let temp of this.configuredData) {
            for (let not of this.notificationList) {
              if (temp.service.toLowerCase() == not.key.toLowerCase()) {
                {
                  this.configuredList.push(not);
                }

                if (not.key.toLowerCase() == "whatsapp") {
                  this.whatsappConfigured = true;
                }
                if (not.key.toLowerCase() == "inapp") {
                  this.inappConfigured = true;
                }
              }
            }
          }
          this.checkRow();
        });
    },
    saveWhatsappConfig() {
      if (
        this.whatsConfig.fromName != "" &&
        this.whatsConfig.from != "" &&
        this.whatsConfig.apiKey != ""
      ) {
        this.whatsappConfig.tenant = this.$currentUserData._id;
        this.whatsappConfig.config = this.whatsConfig;
        this.whatsappConfig.enable = true;
        this.$store
          .dispatch("tenant/configureNotificationAction", this.whatsappConfig)
          .then(() => {
            this.whatsConfig = { fromName: "", from: "", apiKey: "" };
            this.getNotificationList();
            this.whatsappModal = false;
          });
      } else {
        this.$swal({
          title: "Error",
          text: "Enter Required Fields",
          type: "warning",
        });
      }
    },
    emailSaveConfig() {
      if (
        this.whatsConfig.fromName != "" &&
        this.whatsConfig.from != "" &&
        this.emailConfig.serviceProvider != "" &&
        this.whatsConfig.apiKey != ""
      ) {
        this.emailConfig.tenant = this.$currentUserData._id;
        this.emailConfig.config = this.whatsConfig;
        this.emailConfig.enable = true;

        this.$store
          .dispatch("tenant/configureNotificationAction", this.emailConfig)
          .then(() => {
            this.whatsConfig = { fromName: "", from: "", apiKey: "" };
            this.getNotificationList();
            this.emailModal = false;
          });
      } else {
        this.$swal({
          title: "Error",
          text: "Enter Required Fields",
          type: "warning",
        });
      }
    },
    saveSmsConfig() {
      if (
        this.smsConfig.serviceProvider != "" &&
        this.smConfig.username != "" &&
        this.smConfig.token != ""
      ) {
        this.smsConfig.tenant = this.$currentUserData._id;
        this.smsConfig.config = this.smConfig;
        this.smsConfig.enable = true;

        this.$store
          .dispatch("tenant/configureNotificationAction", this.smsConfig)
          .then(() => {
            this.smConfig = { username: "", token: "" };
            this.notificationList = [];
            this.firstRow = [];
            this.secondRow = [];
            this.thirdRow = [];
            this.getNotificationList();
            this.smsModal = false;
          });
      } else {
        this.$swal({
          title: "Error",
          text: "Enter Required Fields",
          type: "warning",
        });
      }
    },
    checkRow() {
      this.firstRow = [];
      this.secondRow = [];
      this.thirdRow = [];
      for (let temp of this.notificationList) {
        const normalizedKey = (temp.key || "").toString().toLowerCase();
        if (normalizedKey === "whatsapp" || normalizedKey === "inapp") {
          if (normalizedKey === "whatsapp" && !this.whatsappConfigured)
            this.firstRow.push(temp);
          if (normalizedKey === "inapp" && !this.inappConfigured)
            this.firstRow.push(temp);
        } else if (normalizedKey === "sms") {
          this.secondRow.push(temp);
        } else {
          this.thirdRow.push(temp);
        }
      }
    },
    getServiceProvider() {
      this.$store.dispatch("tenant/getServiceProvidersAction").then(() => {
        for (let temp of this.serviceProviders) {
          if (temp.type === "SMS") {
            this.smsProviders.push(temp);
          }
          if (temp.type === "EMAIL") {
            this.emailProviders.push(temp);
          }
        }
      });
    },
  },
  mounted() {
    this.getNotificationList();
    this.getServiceProvider();
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style lang="scss">
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-img-top {
  height: 70px;
  width: auto;
  max-width: 100%;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.center {
  text-align: center;
}
.horizontal-line {
  border-top: 1.5px dashed #d8e1e7;
}
.notification-switch {
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-switch ::v-deep .switch,
.notification-switch ::v-deep .form-check-label {
  min-width: 5rem;
}
.notification-switch ::v-deep .switch-slider {
  min-width: 5rem;
  height: 1.5rem;
}
.notification-switch ::v-deep .switch-primary .switch-input:checked + .switch-slider {
  background-color: #34a853;
  border-color: #34a853;
}
.notification-empty-state {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 2rem 1rem;
}

.notification-empty-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--secondary);
  margin-bottom: 0.5rem;
}

.notification-empty-text {
  color: #6c757d;
}
.search-container {
  display: block;
  margin: 0 auto;
}

input#search-bar {
  margin: 0 auto;
  width: 80%;
  height: 35px;
  padding: 0 20px;
  font-size: 1rem;
  border: 1px solid #d0cfce;
  outline: none;
  &:focus {
    border: 1px solid #008abf;
    transition: 0.35s ease;
    color: #008abf;
    &::-webkit-input-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &::-moz-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &:-ms-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
  }
}

.description {
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  min-height: 6rem;
  -webkit-box-orient: vertical;
}

.header-text .modal-title {
  font-size: 1.2rem;
  color: var(--primary);
  text-align: left;
  margin-left: 0%;
}
.modal-content {
  padding: 1rem;
}
select.form-control:not([size]):not([multiple]) {
  height: calc(3.2125rem - 6px);
}
</style>
